import MaskedField from "../../BaseInputFields/MaskedField/MaskedField";
import { FieldLabeledProps, PhoneNumberProps } from "../../types/fieldTypes";

export interface PhoneNumberFieldProps extends PhoneNumberProps {
  labelProps?: FieldLabeledProps;
  disableToolTip?: boolean;
}

export const PhoneNumberField: React.FC<PhoneNumberFieldProps> = ({
  labelProps,
  label,
  description,
  value,
  disabled,
  onSubmit,
  hidden,
  errorMessages,
  isRequired,
  disableToolTip,
}) => {
  return (
    <MaskedField
      type="Text"
      labelProps={labelProps}
      label={label}
      description={description}
      value={value}
      mask={"([0-9][0-9][0-9]) [0-9][0-9][0-9]-[0-9][0-9][0-9][0-9]"}
      placeholder={"(123) 456-7890"}
      disabled={disabled}
      onSubmit={onSubmit}
      hidden={hidden}
      errorMessages={errorMessages}
      isRequired={isRequired}
      disableToolTip={disableToolTip}
    />
  );
};

export default PhoneNumberField;
